<template>
	<div class="limit-bac open-limit">
		<div class="limit-main">
			<div class="limit-main-box">
				<div class="limit-title">{{ $t("text016") }}</div>
				<div class="limit-content">
					{{ $t("nonvipuserscanonlycompress") }}{{ size ? size : "2MB" }}{{ $t("below")
					}}{{ routetype }}{{ $t("file") }}
				</div>
				<div class="limit-img">
					<img :src="imgSrc" alt="" />
				</div>
				<div class="limit-VIP" @click="toVIP">
					<span>{{ $t("openvip") }}</span>
				</div>
			</div>
			<div class="limit-main-close" @click="closeLimit()"></div>
		</div>
	</div>
</template>
<script>
import ShopVue from "../dialogs/Shop";
import LoginVue from "./Login.vue";
export default {
	name: "LimitMain",
	data() {
		return {
			routetype: "",
			size: "",
			imgSrc: null,
		};
	},
	watch: {},
	methods: {
		toVIP() {
			gevt(
				"文件大小限制弹窗_开通VIP",
				"点击事件",
				`${this.routetype}压缩`,
				"None",
				this.$app.VIPState,
				"None"
			);
			//没登陆用户+非VIP用户
			if (this.$app.isLogin) {
				//登陆成功，判断是否是VIP
				if (!this.$app.VIPlevel) {
					//非VIP打开收银台
					gevt(
						"收银台展示量",
						"收银台事件",
						this.$app.theWayToShop,
						"None",
						this.$app.VIPState,
						"None"
					);
					this.$dlg.show(ShopVue).then((res) => {
						this.closeLimit();
					});
				} else {
					this.closeLimit();
				}
			} else {
				this.$dlg.show(LoginVue).then((res) => {
					if (this.$app.isLogin) this.toVIP();
					else this.closeLimit();
				});
			}
		},
		closeLimit(flag) {
			this.$emit("close", flag);
		},
	},
	mounted() {
		if (this.$route.path == "/main/tpys") {
			this.routetype = this.$t("picture");
			this.size = "200KB";
			this.imgSrc = require("../../mycomponents/img/main-limit/new-limit/pic_tupian@2x.png");
		} else if (this.$route.path == "/main/spys") {
			this.routetype = this.$t("video");
			this.imgSrc = require("../../mycomponents/img/main-limit/new-limit/pic_shipin@2x.png");
		} else if (this.$route.path == "/main/wordys") {
			this.routetype = "Word";
			this.imgSrc = require("../../mycomponents/img/main-limit/new-limit/pic_wenjian@2x.png");
		} else if (this.$route.path == "/main/pptys") {
			this.routetype = "PPT";
			this.imgSrc = require("../../mycomponents/img/main-limit/new-limit/yasuo_1@2x.png");
		} else if (this.$route.path == "/main/pdfys") {
			this.routetype = "PDF";
			this.imgSrc = require("../../mycomponents/img/main-limit/new-limit/pic_pdf@2x.png");
		}
		console.log("大小限制弹窗monted");
		gevt(
			"文件大小限制弹窗",
			"视图事件",
			`${this.routetype}压缩`,
			"None",
			this.$app.VIPState,
			"None"
		);
	},
};
</script>

<style>
.limit-bac {
	position: fixed;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	z-index: 9998;
	background: rgba(0, 0, 0, 0.4);
	/* display: flex; */
	display: none;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}
.limit-main {
	height: 400rem;
	width: 600rem;
	position: absolute;
	z-index: 9999;
	/* display: none; */
	background: white;
	border-radius: 8rem;
	display: flex;
	justify-content: center;
	align-items: center;
}
.limit-main-box {
	/* width: 80%;
	height: 88%; */
	/* border: 1rem solid black; */
}
.limit-title {
	font-size: 24rem;
	font-family: Microsoft YaHei;
	font-weight: bold;
	/* line-height: 30px; */
	color: #1b212e;
	opacity: 1;
	text-align: center;
	margin-top: 28rem;
}
.limit-img {
	/* border: 1rem solid black; */
	margin: 31rem auto 38rem;
	width: 484rem;
	height: 170rem;
}
.limit-img img {
	width: 100%;
}
.limit-content {
	width: 80%;
	margin: 0rem auto;
	padding: 10rem 0 0 0;
	text-align: center;
	font-size: 14rem;
	line-height: 23rem;
	color: #7889ab;
}
.limit-VIP {
	width: 200rem;
	height: 35rem;
	margin: 25rem auto;
	background: linear-gradient(44deg, #f6da65 0%, #ffc43e 100%);
	opacity: 1;
	text-align: center;
	border-radius: 15rem;
	margin-bottom: 23rem;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 999;
}
.limit-VIP:hover {
	background: #f7d688d7;
}
.limit-VIP span {
	display: inline-block;
	padding: 0 0 2rem 0;
	vertical-align: middle;
	font-size: 16rem;
	font-family: Microsoft YaHei;
	font-weight: 400;
	/* line-height: 19rem; */
	color: #3e2e09;
	opacity: 1;
}
.limit-close {
	position: absolute;
	top: 5rem;
	right: 5rem;
}
.limit-main-close {
	position: absolute;
	right: 12rem;
	top: 0;
	width: 24rem;
	height: 40rem;
	background-image: url("../../mycomponents/img/main-limit/icon_syt_gb01@2x.png");
	background-size: cover;
	cursor: pointer;
}

/* js */
.open-limit {
	display: flex !important;
}
</style>
